import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { isFramed, openTopLevel } from "@/lib/topNavigation";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { usePrice } from "@/components/market/Plans";

export const CustomOfferPay = ({ offer, onPaid, disabled, forced, testId = "custom-pay-btn" }) => {
  const { t } = useI18n();
  const { cur } = usePrice(forced);
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState(null);
  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/dev/billing/custom", { origin_url: window.location.origin, currency: cur });
      if (data.checkout_url) {
        if (isFramed()) setUrl(data.checkout_url);
        openTopLevel(data.checkout_url);
        return;
      }
      toast.success(t("plans.changed"));
      onPaid?.(data.billing);
    } catch (err) {
      toast.error(translateError(err, t));
    }
    setBusy(false);
  };
  return (
    <div className="mt-2">
      <button type="button" className="btn-red btn-sm h-auto max-w-full !whitespace-normal text-start leading-snug" onClick={pay} disabled={busy || disabled} data-testid={testId}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />} {t("custom.pay")}
      </button>
      {url && <a href={url} target="_top" rel="noopener" className="ms-2 text-xs text-amber-200 underline" data-testid={`${testId}-link`}>{t("custom.pay")}</a>}
    </div>
  );
};
